module.exports = __webpack_public_path__ + "static/media/spritual1.b897b6d0.webp";